import {Component, EventEmitter, Output} from '@angular/core';
import {VeiculoSimples} from '../../../models/arrendamento/veiculo-simples.model';
import {ModalService} from '../../../services/modal.service';
import {VeiculosService} from '../../../services/veiculos.service';

@Component({
    selector: 'buscar-veiculo-contrato-arrendamento',
    templateUrl: 'buscar-veiculo-contrato-arrendamento.component.html',
    styleUrls: ['buscar-veiculo-contrato-arrendamento.component.scss']
})

export class BuscarVeiculoContratoArrendamentoComponent {
    valorPesquisa: string = '';

    @Output()
    onVeiculoChange = new EventEmitter<VeiculoSimples>();

    constructor(private veiculoService: VeiculosService, private modalService: ModalService) {}

    onVeiculoSearch() {
        this.veiculoService.buscarPlaca(this.valorPesquisa).then(
            result => {
                if (!result.data.codigo) {
                    this.modalService.important('Veículo não encontrado.');

                } else {
                    const veiculo: VeiculoSimples = {
                        placa: result.data.placa,
                        renavam: result.data.renavam,
                        cpfCnpjArrendante: result.data.cpfCnpjProprietario,
                        nomeArrendante: result.data.possuidorVeiculo
                    }

                    this.onVeiculoChange.emit(veiculo);
                }
            },
            error => {
                this.modalService.error('Ocorreu um erro no serviço de busca do veículo !');
            }
        );
    }
}
